export default __webpack_public_path__ + "static/media/testimonials-bg.e8fc80d0.jpg";